// SPDX-License-Identifier: MIT
export const WORDLIST = [
    'абзац',
    'абонент',
    'абсурд',
    'авангард',
    'авария',
    'август',
    'авиация',
    'автор',
    'агент',
    'агитация',
    'агрегат',
    'адвокат',
    'адмирал',
    'адрес',
    'азарт',
    'азот',
    'академия',
    'аквариум',
    'аксиома',
    'акула',
    'акцент',
    'акция',
    'аллея',
    'алмаз',
    'алтарь',
    'альбом',
    'альянс',
    'амбиция',
    'анализ',
    'анекдот',
    'анкета',
    'ансамбль',
    'антенна',
    'апельсин',
    'аппарат',
    'аппетит',
    'апрель',
    'аптека',
    'арбуз',
    'аргумент',
    'аренда',
    'арест',
    'армия',
    'аромат',
    'арсенал',
    'артерия',
    'артист',
    'архив',
    'аспирант',
    'асфальт',
    'атака',
    'атомный',
    'атрибут',
    'аукцион',
    'афиша',
    'аэропорт',
    'бабочка',
    'бабушка',
    'багаж',
    'база',
    'бактерия',
    'баланс',
    'балерина',
    'балкон',
    'бандит',
    'банк',
    'барабан',
    'барон',
    'барышня',
    'барьер',
    'бассейн',
    'батарея',
    'башмак',
    'башня',
    'бедный',
    'беженец',
    'бездна',
    'белка',
    'белый',
    'бензин',
    'берег',
    'беседа',
    'бешеный',
    'билет',
    'бинокль',
    'биржа',
    'битва',
    'благо',
    'блеск',
    'близкий',
    'блин',
    'блок',
    'блюдо',
    'богатый',
    'бодрый',
    'боец',
    'бокал',
    'боковой',
    'бокс',
    'более',
    'болото',
    'болтать',
    'большой',
    'бомба',
    'борт',
    'борьба',
    'босой',
    'ботинок',
    'бояться',
    'брак',
    'брать',
    'бревно',
    'бред',
    'бригада',
    'бродяга',
    'броня',
    'бросить',
    'брызги',
    'брюки',
    'брюхо',
    'бугор',
    'будка',
    'будни',
    'будущее',
    'буква',
    'букет',
    'бульвар',
    'бумага',
    'бунт',
    'бурный',
    'буря',
    'бутылка',
    'бухта',
    'бывший',
    'быстро',
    'бытовой',
    'быть',
    'бюджет',
    'бюро',
    'бюст',
    'вагон',
    'важный',
    'вакцина',
    'валенок',
    'вальс',
    'валюта',
    'ванная',
    'варенье',
    'вариант',
    'вблизи',
    'вверх',
    'вводить',
    'вдали',
    'вдвое',
    'вдова',
    'вдоль',
    'вдруг',
    'ведро',
    'ведущий',
    'ведьма',
    'вежливо',
    'везде',
    'веко',
    'вексель',
    'велеть',
    'великий',
    'венец',
    'веник',
    'веранда',
    'верблюд',
    'верить',
    'верный',
    'версия',
    'вертеть',
    'верхний',
    'вершина',
    'весело',
    'весна',
    'весомый',
    'вести',
    'весь',
    'ветеран',
    'ветхий',
    'вечер',
    'вечно',
    'вешалка',
    'вещество',
    'взамен',
    'взгляд',
    'вздох',
    'взнос',
    'взойти',
    'взор',
    'взрыв',
    'взять',
    'видеть',
    'видимо',
    'визг',
    'визит',
    'вилка',
    'вина',
    'вирус',
    'висок',
    'витамин',
    'витрина',
    'вихрь',
    'вишня',
    'вкус',
    'влага',
    'владелец',
    'власть',
    'влево',
    'влияние',
    'вложить',
    'вместе',
    'внешний',
    'вникать',
    'внимание',
    'вновь',
    'внук',
    'внутри',
    'внучка',
    'внушать',
    'вовлечь',
    'вовремя',
    'вовсю',
    'вода',
    'водород',
    'водяной',
    'воевать',
    'возврат',
    'возглас',
    'воздух',
    'возить',
    'возле',
    'возня',
    'возраст',
    'война',
    'войско',
    'вокзал',
    'волос',
    'волчий',
    'вольный',
    'воля',
    'вообще',
    'вопль',
    'вопрос',
    'ворота',
    'восемь',
    'восток',
    'вплоть',
    'вполне',
    'вправе',
    'впредь',
    'впрочем',
    'врач',
    'вредный',
    'время',
    'вручить',
    'всадник',
    'всегда',
    'вскоре',
    'вскрыть',
    'всплеск',
    'вспышка',
    'встреча',
    'всюду',
    'всякий',
    'второй',
    'вход',
    'вчера',
    'выбор',
    'вывод',
    'выгнать',
    'выдать',
    'выехать',
    'вызов',
    'выйти',
    'выкуп',
    'вылезти',
    'вымыть',
    'выпасть',
    'выпить',
    'выплата',
    'выпуск',
    'вырасти',
    'выручка',
    'выслать',
    'высокий',
    'выставка',
    'вышка',
    'вязать',
    'вялый',
    'газета',
    'газовый',
    'галерея',
    'галстук',
    'гамма',
    'гарантия',
    'гармония',
    'гарнизон',
    'гастроли',
    'гвардия',
    'гвоздь',
    'гектар',
    'генерал',
    'гений',
    'геном',
    'геолог',
    'герб',
    'герой',
    'гибкий',
    'гигант',
    'гимн',
    'гипотеза',
    'гитара',
    'главный',
    'глагол',
    'гладить',
    'глаз',
    'глина',
    'глоток',
    'глубокий',
    'глупый',
    'глухой',
    'глыба',
    'глядеть',
    'гнев',
    'гнездо',
    'гнилой',
    'годовой',
    'голова',
    'голубой',
    'голый',
    'гонорар',
    'гордость',
    'горизонт',
    'горло',
    'горный',
    'город',
    'горшок',
    'горький',
    'горючее',
    'горячий',
    'готовый',
    'градус',
    'грамм',
    'граница',
    'граф',
    'гребень',
    'гриб',
    'гримаса',
    'грозить',
    'грохот',
    'грош',
    'грубый',
    'грудь',
    'груз',
    'грунт',
    'группа',
    'груша',
    'грязный',
    'губа',
    'гудок',
    'гулкий',
    'гулять',
    'гусеница',
    'густо',
    'гусь',
    'давление',
    'давно',
    'даже',
    'дальний',
    'данный',
    'дарить',
    'датчик',
    'дать',
    'дача',
    'двадцать',
    'дважды',
    'дверь',
    'двигать',
    'движение',
    'двойной',
    'двор',
    'дебют',
    'девятый',
    'дежурный',
    'действие',
    'декабрь',
    'деление',
    'дело',
    'дельфин',
    'день',
    'дерево',
    'держать',
    'дерзкий',
    'десять',
    'деталь',
    'детский',
    'дефект',
    'дефицит',
    'деятель',
    'джаз',
    'джинсы',
    'джунгли',
    'диагноз',
    'диалог',
    'диапазон',
    'диван',
    'дивизия',
    'дивный',
    'диета',
    'дизайн',
    'дикарь',
    'дилер',
    'динамика',
    'диплом',
    'директор',
    'дитя',
    'длинный',
    'дневник',
    'добрый',
    'добыча',
    'доверие',
    'догадка',
    'догнать',
    'дождь',
    'доклад',
    'доктор',
    'документ',
    'долго',
    'должен',
    'долина',
    'донос',
    'дорога',
    'досада',
    'доска',
    'достать',
    'досуг',
    'доход',
    'доцент',
    'дощатый',
    'драка',
    'древний',
    'дремать',
    'дробный',
    'дрова',
    'дрожать',
    'другой',
    'дружба',
    'дубовый',
    'дуга',
    'думать',
    'дурной',
    'духи',
    'душный',
    'дуэль',
    'дуэт',
    'дыра',
    'дыхание',
    'дюжина',
    'дядя',
    'едва',
    'единый',
    'ерунда',
    'если',
    'ехать',
    'жадный',
    'жажда',
    'жалеть',
    'жалоба',
    'жанр',
    'жареный',
    'жаркий',
    'жгучий',
    'жевать',
    'желание',
    'желудок',
    'жена',
    'женщина',
    'жертва',
    'жест',
    'жидкость',
    'житель',
    'жить',
    'жрец',
    'жулик',
    'журнал',
    'жуткий',
    'забрать',
    'забыть',
    'завести',
    'завод',
    'завтра',
    'загадка',
    'загнать',
    'заговор',
    'задача',
    'задеть',
    'задний',
    'задолго',
    'заехать',
    'заказ',
    'закон',
    'закрыть',
    'закуска',
    'залезть',
    'залить',
    'залп',
    'замок',
    'замуж',
    'замысел',
    'занавес',
    'заново',
    'занять',
    'заодно',
    'запись',
    'запрос',
    'запуск',
    'запястье',
    'заранее',
    'заросль',
    'зарплата',
    'заря',
    'засада',
    'заслуга',
    'заснуть',
    'застать',
    'затвор',
    'затеять',
    'затрата',
    'затылок',
    'захват',
    'зачем',
    'защита',
    'заявить',
    'заяц',
    'звезда',
    'звено',
    'звонить',
    'здесь',
    'зелень',
    'земля',
    'зеркало',
    'зерно',
    'зима',
    'злой',
    'змея',
    'знамя',
    'знание',
    'значит',
    'золотой',
    'зона',
    'зонтик',
    'зоопарк',
    'зрачок',
    'зрение',
    'зритель',
    'зубной',
    'зубр',
    'игла',
    'идеал',
    'идеолог',
    'идея',
    'идол',
    'идти',
    'изба',
    'избить',
    'избрать',
    'избыток',
    'извлечь',
    'извне',
    'изгиб',
    'изгнать',
    'издание',
    'изделие',
    'изнутри',
    'изобилие',
    'изоляция',
    'изредка',
    'изрядно',
    'изучение',
    'изъять',
    'изящный',
    'икона',
    'икра',
    'иллюзия',
    'именно',
    'иметь',
    'имидж',
    'империя',
    'импульс',
    'иначе',
    'инвалид',
    'индекс',
    'индивид',
    'инерция',
    'инженер',
    'иногда',
    'иной',
    'институт',
    'интерес',
    'интрига',
    'интуиция',
    'инфаркт',
    'инцидент',
    'ирония',
    'искать',
    'испуг',
    'история',
    'итог',
    'июнь',
    'кабель',
    'кабинет',
    'каблук',
    'кавалер',
    'кадр',
    'каждый',
    'кажется',
    'казино',
    'калитка',
    'камень',
    'камин',
    'канал',
    'кандидат',
    'каникулы',
    'канон',
    'капитан',
    'капля',
    'капот',
    'капуста',
    'карандаш',
    'карета',
    'каркас',
    'карман',
    'картина',
    'карьера',
    'каска',
    'кассета',
    'кастрюля',
    'каталог',
    'катер',
    'каток',
    'катушка',
    'кафедра',
    'качество',
    'каша',
    'кашлять',
    'каюта',
    'квадрат',
    'квартира',
    'квота',
    'кепка',
    'кивнуть',
    'километр',
    'кино',
    'киоск',
    'кипяток',
    'кирпич',
    'кислота',
    'кисть',
    'клавиша',
    'клапан',
    'класс',
    'клей',
    'клетка',
    'клиент',
    'климат',
    'клиника',
    'кличка',
    'клоун',
    'клочок',
    'клуб',
    'клумба',
    'ключ',
    'книга',
    'кнопка',
    'кнут',
    'княгиня',
    'князь',
    'кобура',
    'когда',
    'кодекс',
    'кожа',
    'коктейль',
    'колено',
    'коллега',
    'колонна',
    'колпак',
    'кольцо',
    'колючий',
    'коляска',
    'команда',
    'комедия',
    'комиссия',
    'коммуна',
    'комната',
    'комок',
    'компания',
    'комфорт',
    'конвейер',
    'конгресс',
    'конечно',
    'конкурс',
    'контроль',
    'концерт',
    'конь',
    'конюшня',
    'копать',
    'копейка',
    'копыто',
    'корабль',
    'корень',
    'корзина',
    'коридор',
    'кормить',
    'корпус',
    'космос',
    'костюм',
    'косяк',
    'котел',
    'котлета',
    'который',
    'коттедж',
    'кофе',
    'кофта',
    'кошка',
    'кража',
    'край',
    'красный',
    'краткий',
    'кредит',
    'крем',
    'крепкий',
    'кресло',
    'кривой',
    'кризис',
    'кристалл',
    'критерий',
    'кричать',
    'кровь',
    'крокодил',
    'кролик',
    'кроме',
    'крона',
    'круг',
    'кружка',
    'крупный',
    'крутой',
    'крушение',
    'крыло',
    'крыша',
    'крючок',
    'кстати',
    'кубик',
    'куда',
    'кузов',
    'кукла',
    'кулак',
    'кулиса',
    'культура',
    'кумир',
    'купе',
    'купить',
    'купол',
    'купюра',
    'курица',
    'курорт',
    'курс',
    'куртка',
    'кусок',
    'куст',
    'кухня',
    'кушать',
    'лабиринт',
    'лавка',
    'лагерь',
    'ладно',
    'ладонь',
    'лапа',
    'лауреат',
    'лгать',
    'лебедь',
    'левый',
    'легенда',
    'легкий',
    'ледяной',
    'лежать',
    'лезвие',
    'лезть',
    'лекция',
    'ленивый',
    'лента',
    'лепесток',
    'лесной',
    'лестница',
    'лететь',
    'лето',
    'лечить',
    'лига',
    'лидер',
    'лиловый',
    'лимон',
    'линия',
    'липкий',
    'лист',
    'литр',
    'лихой',
    'лицо',
    'лишить',
    'лишний',
    'ловить',
    'логика',
    'лодка',
    'ложь',
    'лозунг',
    'локоть',
    'лопата',
    'лошадь',
    'лукавый',
    'луна',
    'лучший',
    'лысый',
    'льгота',
    'любить',
    'любой',
    'людской',
    'люстра',
    'лютый',
    'лягушка',
    'магазин',
    'магия',
    'майор',
    'майский',
    'максимум',
    'макушка',
    'мало',
    'мальчик',
    'мама',
    'манера',
    'марка',
    'март',
    'маршрут',
    'масса',
    'мастер',
    'масштаб',
    'материал',
    'матч',
    'махать',
    'машина',
    'маяк',
    'мебель',
    'медаль',
    'медведь',
    'медицина',
    'медь',
    'между',
    'мелкий',
    'мелочь',
    'мемуары',
    'меньше',
    'меню',
    'менять',
    'мера',
    'мерцать',
    'место',
    'месяц',
    'металл',
    'метод',
    'метр',
    'механизм',
    'меховой',
    'мечтать',
    'мешать',
    'мешок',
    'миграция',
    'микрофон',
    'милиция',
    'миллион',
    'милость',
    'миля',
    'мимо',
    'минерал',
    'министр',
    'минута',
    'мирный',
    'миска',
    'миссия',
    'митинг',
    'мишень',
    'младший',
    'мнение',
    'мнимый',
    'много',
    'могучий',
    'модель',
    'может',
    'мозг',
    'мокрый',
    'молекула',
    'молния',
    'молодой',
    'молчать',
    'момент',
    'монета',
    'монитор',
    'монолог',
    'монстр',
    'монтаж',
    'мораль',
    'море',
    'морковь',
    'мороз',
    'морщина',
    'мостовая',
    'мотать',
    'мотив',
    'мотор',
    'мохнатый',
    'мрамор',
    'мрачный',
    'мстить',
    'мудрый',
    'мужество',
    'мужчина',
    'музей',
    'музыка',
    'мундир',
    'муравей',
    'мусор',
    'муха',
    'мчаться',
    'мысль',
    'мыться',
    'мышца',
    'мышь',
    'мюзикл',
    'мягкий',
    'мясо',
    'набор',
    'навык',
    'наглый',
    'нагрузка',
    'надежда',
    'надзор',
    'надо',
    'наедине',
    'назад',
    'название',
    'назло',
    'наивный',
    'найти',
    'наконец',
    'налево',
    'наличие',
    'налог',
    'намерен',
    'нанести',
    'напасть',
    'например',
    'народ',
    'наследие',
    'натура',
    'наука',
    'наутро',
    'начать',
    'небо',
    'неважно',
    'невеста',
    'негодяй',
    'недавно',
    'неделя',
    'недолго',
    'недра',
    'недуг',
    'нежный',
    'незачем',
    'некто',
    'нелепый',
    'неловко',
    'нельзя',
    'немало',
    'немой',
    'неплохо',
    'нервный',
    'нередко',
    'нестись',
    'неудача',
    'неужели',
    'нефть',
    'неясный',
    'нигде',
    'низкий',
    'никакой',
    'никогда',
    'никуда',
    'ничто',
    'ничуть',
    'ниша',
    'нищий',
    'новость',
    'новый',
    'нога',
    'ноготь',
    'ножницы',
    'ноздря',
    'номер',
    'носить',
    'носок',
    'ночь',
    'ноябрь',
    'нрав',
    'нуль',
    'нынче',
    'нырять',
    'нюанс',
    'няня',
    'обаяние',
    'обед',
    'обезьяна',
    'обещать',
    'обжечь',
    'обзор',
    'обилие',
    'обитать',
    'область',
    'облик',
    'обложка',
    'обмен',
    'обморок',
    'обожать',
    'обои',
    'оболочка',
    'оборона',
    'обочина',
    'образ',
    'обрести',
    'обрыв',
    'обувь',
    'обучение',
    'обход',
    'общество',
    'общий',
    'объект',
    'обыск',
    'обычно',
    'обязать',
    'овощи',
    'овраг',
    'овца',
    'оговорка',
    'ограда',
    'огурец',
    'одежда',
    'одеяло',
    'один',
    'однако',
    'одолеть',
    'ожидать',
    'озеро',
    'океан',
    'окно',
    'около',
    'окоп',
    'окраина',
    'октябрь',
    'опасный',
    'опека',
    'операция',
    'описание',
    'оплата',
    'опора',
    'оппонент',
    'оптимизм',
    'оптовый',
    'опухоль',
    'опыт',
    'оратор',
    'орбита',
    'орган',
    'орден',
    'орел',
    'оригинал',
    'ориентир',
    'оркестр',
    'оружие',
    'осенний',
    'осколок',
    'осмотр',
    'остров',
    'отбор',
    'отбыть',
    'отвлечь',
    'отдать',
    'отдел',
    'отдых',
    'отель',
    'отец',
    'отзыв',
    'отказ',
    'отклик',
    'открыть',
    'откуда',
    'отличие',
    'отныне',
    'отойти',
    'отпуск',
    'отрасль',
    'отросток',
    'отрывок',
    'отряд',
    'отсек',
    'отставка',
    'отсюда',
    'оттенок',
    'оттого',
    'отчего',
    'отъезд',
    'офис',
    'офицер',
    'охота',
    'охрана',
    'оценка',
    'очаг',
    'очень',
    'очередь',
    'очищать',
    'ошибка',
    'ощущение',
    'павильон',
    'падать',
    'пазуха',
    'пакет',
    'палата',
    'палец',
    'палуба',
    'пальто',
    'память',
    'панель',
    'паника',
    'пара',
    'парень',
    'пароход',
    'партия',
    'парус',
    'паспорт',
    'пассажир',
    'пастух',
    'патент',
    'патрон',
    'пауза',
    'паук',
    'паутина',
    'пафос',
    'пахнуть',
    'пациент',
    'пачка',
    'певец',
    'педагог',
    'пейзаж',
    'пенсия',
    'пепел',
    'первый',
    'перед',
    'период',
    'перо',
    'перрон',
    'персонаж',
    'перчатка',
    'песня',
    'песок',
    'петля',
    'петрушка',
    'петух',
    'пехота',
    'печать',
    'печень',
    'пешком',
    'пещера',
    'пианист',
    'пиджак',
    'пилот',
    'пионер',
    'пирамида',
    'пирожок',
    'письмо',
    'пища',
    'плавание',
    'плакать',
    'пламя',
    'план',
    'пласт',
    'платить',
    'пленный',
    'плечо',
    'плита',
    'плод',
    'плоский',
    'плотный',
    'плохой',
    'площадь',
    'плыть',
    'плюс',
    'пляж',
    'плясать',
    'победа',
    'повар',
    'повод',
    'повсюду',
    'повязка',
    'погода',
    'погреб',
    'подбор',
    'подвиг',
    'подделка',
    'поджать',
    'поднос',
    'подпись',
    'подруга',
    'подход',
    'подчас',
    'подъезд',
    'поединок',
    'поезд',
    'поесть',
    'поехать',
    'пожалуй',
    'пожилой',
    'позади',
    'позвать',
    'поздний',
    'позиция',
    'позор',
    'поиск',
    'поймать',
    'пойти',
    'поклон',
    'покой',
    'покрыть',
    'полдень',
    'полезный',
    'ползти',
    'полк',
    'полный',
    'половина',
    'полтора',
    'польза',
    'поляна',
    'помидор',
    'помнить',
    'помощь',
    'попасть',
    'поперек',
    'поплыть',
    'пополам',
    'поправка',
    'попугай',
    'попытка',
    'порог',
    'портрет',
    'порция',
    'порыв',
    'порядок',
    'после',
    'посол',
    'посреди',
    'постель',
    'посуда',
    'потом',
    'похвала',
    'похожий',
    'поцелуй',
    'почва',
    'почему',
    'пошлина',
    'поэма',
    'поэтому',
    'право',
    'праздник',
    'практика',
    'прах',
    'преграда',
    'предмет',
    'прежде',
    'прелесть',
    'премия',
    'препарат',
    'пресса',
    'прибыть',
    'прижать',
    'прийти',
    'приказ',
    'прилавок',
    'пример',
    'принять',
    'природа',
    'притом',
    'прихожая',
    'прицел',
    'причина',
    'приют',
    'прогноз',
    'продукт',
    'проект',
    'прожить',
    'прокат',
    'промысел',
    'пропуск',
    'просто',
    'против',
    'профиль',
    'процесс',
    'прочий',
    'прошлый',
    'прощать',
    'пружина',
    'прут',
    'прыжок',
    'прямой',
    'птица',
    'публика',
    'пугать',
    'пуговица',
    'пузырь',
    'пульт',
    'пуля',
    'пункт',
    'пускать',
    'пустой',
    'путь',
    'пухлый',
    'пучок',
    'пушистый',
    'пушка',
    'пчела',
    'пшеница',
    'пылать',
    'пыль',
    'пышный',
    'пьеса',
    'пятка',
    'пятно',
    'пятый',
    'пятьсот',
    'работа',
    'равнина',
    'ради',
    'радость',
    'радуга',
    'разбить',
    'развитие',
    'разговор',
    'раздел',
    'различие',
    'размер',
    'разный',
    'разрыв',
    'разум',
    'район',
    'ракета',
    'раковина',
    'рамка',
    'рано',
    'рапорт',
    'распад',
    'рассказ',
    'расти',
    'расход',
    'расцвет',
    'рация',
    'рвануть',
    'рваться',
    'реакция',
    'ребро',
    'реветь',
    'редактор',
    'редкий',
    'реестр',
    'режим',
    'резать',
    'резерв',
    'резина',
    'резко',
    'резной',
    'рейс',
    'реклама',
    'рекорд',
    'религия',
    'рельс',
    'ремень',
    'ремонт',
    'реплика',
    'репортаж',
    'ресница',
    'ресторан',
    'реформа',
    'рецепт',
    'речь',
    'решение',
    'ржавый',
    'риск',
    'рисунок',
    'ритуал',
    'рифма',
    'робко',
    'робот',
    'ровесник',
    'ровно',
    'родной',
    'рождение',
    'роза',
    'розовый',
    'розыск',
    'роль',
    'роман',
    'роскошь',
    'роспись',
    'рост',
    'рубашка',
    'рубеж',
    'рубить',
    'рубрика',
    'рудник',
    'рука',
    'рукопись',
    'румяный',
    'русло',
    'рухнуть',
    'ручей',
    'ручной',
    'рыба',
    'рыжий',
    'рынок',
    'рыхлый',
    'рыцарь',
    'рычаг',
    'рюкзак',
    'рядом',
    'садовый',
    'сажать',
    'салон',
    'салфетка',
    'салют',
    'самец',
    'самовар',
    'самый',
    'сани',
    'санкция',
    'сапог',
    'сарай',
    'сатира',
    'сахар',
    'сбить',
    'сбоку',
    'сборная',
    'сбыт',
    'свадьба',
    'свалка',
    'сварить',
    'свежий',
    'сверху',
    'свет',
    'свеча',
    'свинья',
    'свист',
    'свитер',
    'свобода',
    'сводка',
    'свой',
    'свыше',
    'связь',
    'сдаться',
    'сделать',
    'сегмент',
    'сегодня',
    'седло',
    'седой',
    'седьмой',
    'сезон',
    'сейф',
    'сейчас',
    'секрет',
    'сектор',
    'секунда',
    'семинар',
    'семья',
    'сенатор',
    'сено',
    'сенсация',
    'сентябрь',
    'сервис',
    'сердце',
    'середина',
    'сержант',
    'серия',
    'серый',
    'сессия',
    'сесть',
    'сетевой',
    'сжатый',
    'сжечь',
    'сзади',
    'сигнал',
    'сиденье',
    'сила',
    'силуэт',
    'сильный',
    'символ',
    'симпатия',
    'симфония',
    'синий',
    'синтез',
    'синяк',
    'сирень',
    'система',
    'ситуация',
    'сияние',
    'сказать',
    'скала',
    'скамейка',
    'скандал',
    'скатерть',
    'скачок',
    'скважина',
    'сквер',
    'сквозь',
    'скелет',
    'скидка',
    'склад',
    'сколько',
    'скорый',
    'скосить',
    'скот',
    'скрипка',
    'скудный',
    'скука',
    'слабый',
    'слава',
    'сладкий',
    'слегка',
    'след',
    'слеза',
    'слепой',
    'слесарь',
    'слишком',
    'слово',
    'слог',
    'сложный',
    'сломать',
    'служба',
    'слух',
    'случай',
    'слышать',
    'слюна',
    'смежный',
    'смелый',
    'сменить',
    'смесь',
    'сметана',
    'смех',
    'смола',
    'смуглый',
    'смутный',
    'смущать',
    'смысл',
    'снайпер',
    'снаряд',
    'сначала',
    'снег',
    'снизу',
    'сниться',
    'сно��а',
    'снять',
    'собака',
    'соблазн',
    'собрание',
    'событие',
    'совесть',
    'совсем',
    'согласие',
    'создать',
    'сознание',
    'созреть',
    'сойтись',
    'сокол',
    'солдат',
    'соленый',
    'солнце',
    'солома',
    'сомнение',
    'сонный',
    'соперник',
    'соратник',
    'сорвать',
    'сосед',
    'сосиска',
    'состав',
    'сотня',
    'соус',
    'союз',
    'спад',
    'спальня',
    'спасти',
    'спектр',
    'сперва',
    'спешить',
    'спина',
    'спирт',
    'список',
    'спичка',
    'сплав',
    'спонсор',
    'спор',
    'способ',
    'справка',
    'спустя',
    'спутник',
    'сразу',
    'средство',
    'срок',
    'срыв',
    'ссора',
    'ссылка',
    'ставить',
    'стадия',
    'стакан',
    'станция',
    'старый',
    'стая',
    'стебель',
    'стекло',
    'стена',
    'степень',
    'стереть',
    'стиль',
    'стимул',
    'стирать',
    'стихи',
    'стоить',
    'стойка',
    'стол',
    'стонать',
    'стопа',
    'сторона',
    'стоянка',
    'страна',
    'стричь',
    'строгий',
    'струя',
    'студент',
    'стук',
    'ступня',
    'стыдно',
    'суббота',
    'субъект',
    'сувенир',
    'сугроб',
    'сугубо',
    'судить',
    'судно',
    'судьба',
    'суета',
    'суметь',
    'сумма',
    'сумрак',
    'сундук',
    'супруг',
    'суровый',
    'сутки',
    'сухой',
    'суша',
    'существо',
    'сфера',
    'схема',
    'схожий',
    'сценарий',
    'счастье',
    'считать',
    'съезд',
    'сыграть',
    'сырой',
    'сытый',
    'сыщик',
    'сюда',
    'сюжет',
    'сюрприз',
    'тайна',
    'также',
    'такой',
    'такси',
    'тактика',
    'талия',
    'таможня',
    'танец',
    'таракан',
    'тарелка',
    'тариф',
    'тащить',
    'таять',
    'тварь',
    'театр',
    'тезис',
    'текст',
    'текущий',
    'телефон',
    'тема',
    'темнота',
    'теневой',
    'теннис',
    'теория',
    'теперь',
    'тепло',
    'терапия',
    'терзать',
    'термин',
    'терпеть',
    'терраса',
    'терять',
    'тесный',
    'тетрадь',
    'техника',
    'течение',
    'тигр',
    'типовой',
    'тираж',
    'титул',
    'тихий',
    'ткань',
    'товарищ',
    'тоже',
    'толпа',
    'толстый',
    'толчок',
    'толщина',
    'только',
    'тонкий',
    'тонна',
    'топить',
    'топор',
    'торговля',
    'тормоз',
    'торчать',
    'тотчас',
    'точка',
    'точно',
    'тощий',
    'трава',
    'традиция',
    'трактор',
    'трамвай',
    'траншея',
    'трасса',
    'тревога',
    'трезвый',
    'тренер',
    'трепет',
    'треск',
    'третий',
    'трещина',
    'трибуна',
    'тридцать',
    'триста',
    'триумф',
    'трогать',
    'тройка',
    'тронуть',
    'тропа',
    'тротуар',
    'трубка',
    'труд',
    'трюк',
    'тряпка',
    'туго',
    'туловище',
    'туман',
    'тумбочка',
    'тундра',
    'тупик',
    'турист',
    'турнир',
    'тусклый',
    'туфля',
    'туча',
    'тысяча',
    'тяга',
    'тяжело',
    'убежать',
    'убогий',
    'уборка',
    'уважение',
    'увезти',
    'уволить',
    'угадать',
    'угол',
    'угощать',
    'угроза',
    'угрюмый',
    'удар',
    'удачный',
    'уделять',
    'удивить',
    'удобный',
    'удочка',
    'уезжать',
    'ужин',
    'узел',
    'узкий',
    'уйти',
    'указание',
    'уклон',
    'украсть',
    'укусить',
    'улетать',
    'улица',
    'улыбка',
    'умело',
    'умение',
    'умный',
    'умолять',
    'унести',
    'унижать',
    'унылый',
    'упаковка',
    'упасть',
    'упорно',
    'упрек',
    'урна',
    'уровень',
    'урожай',
    'уронить',
    'усадьба',
    'усатый',
    'усвоить',
    'усилие',
    'условие',
    'услуга',
    'усмешка',
    'успеть',
    'устав',
    'устоять',
    'утечка',
    'утешать',
    'утро',
    'уцелеть',
    'участие',
    'ученик',
    'учесть',
    'ущелье',
    'ущерб',
    'уютный',
    'фабрика',
    'фаворит',
    'факел',
    'факт',
    'фамилия',
    'фантазия',
    'фасад',
    'февраль',
    'феномен',
    'фермер',
    'фигура',
    'физика',
    'филиал',
    'философ',
    'фильм',
    'финал',
    'флаг',
    'флот',
    'фойе',
    'фокус',
    'фонарь',
    'фонд',
    'фонтан',
    'форма',
    'форум',
    'фото',
    'фрагмент',
    'фраза',
    'фракция',
    'фронт',
    'фрукт',
    'функция',
    'фуражка',
    'футбол',
    'футляр',
    'халат',
    'хаос',
    'характер',
    'хата',
    'хвалить',
    'хватать',
    'хвойный',
    'хвост',
    'химия',
    'хирург',
    'хитрый',
    'хищник',
    'хлеб',
    'хлынуть',
    'хмурый',
    'ходить',
    'хозяин',
    'хоккей',
    'холм',
    'холст',
    'хорошо',
    'хотеть',
    'храбрый',
    'храм',
    'хранить',
    'хребет',
    'хрен',
    'хрипло',
    'хроника',
    'хрупкий',
    'художник',
    'худший',
    'хулиган',
    'хутор',
    'царь',
    'цветок',
    'целевой',
    'целиком',
    'целое',
    'цель',
    'цензура',
    'ценить',
    'центр',
    'цепной',
    'цикл',
    'цилиндр',
    'цирк',
    'цитата',
    'цифра',
    'чайник',
    'часы',
    'чашка',
    'человек',
    'челюсть',
    'чемодан',
    'чемпион',
    'чепуха',
    'червь',
    'чердак',
    'через',
    'чернила',
    'черта',
    'чеснок',
    'честно',
    'четверть',
    'четыре',
    'число',
    'чистый',
    'читатель',
    'чтение',
    'чтобы',
    'чувство',
    'чудак',
    'чудный',
    'чудо',
    'чужой',
    'чулок',
    'чума',
    'чушь',
    'чуять',
    'шагать',
    'шанс',
    'шапка',
    'шарик',
    'шарф',
    'шахматы',
    'шашлык',
    'шедевр',
    'шептать',
    'шерсть',
    'шестой',
    'шинель',
    'ширина',
    'шишка',
    'шкаф',
    'школа',
    'шкура',
    'шланг',
    'шлем',
    'шнур',
    'шоколад',
    'шорох',
    'шоссе',
    'шпион',
    'шприц',
    'штаб',
    'штамм',
    'штаны',
    'штатный',
    'штора',
    'штраф',
    'штурм',
    'штык',
    'шумно',
    'шуршать',
    'шутить',
    'шутка',
    'щедрый',
    'щека',
    'щенок',
    'экзамен',
    'экипаж',
    'экономия',
    'экран',
    'эксперт',
    'элемент',
    'элитный',
    'эмоция',
    'энергия',
    'эпизод',
    'эпоха',
    'эскиз',
    'эстрада',
    'этап',
    'этика',
    'этот',
    'эфир',
    'эффект',
    'эшелон',
    'юбилей',
    'юбка',
    'южный',
    'юмор',
    'юность',
    'юрист',
    'юстиция',
    'яблоко',
    'явление',
    'ягода',
    'ядро',
    'язык',
    'яйцо',
    'якобы',
    'якорь',
    'январь',
    'яркий',
    'ярмарка',
    'ярость',
    'ясный',
    'яхта',
    'ячейка',
    'ящик'
];
//# sourceMappingURL=russian.js.map